import { Box, pn, Skeleton, Stack } from "@compass/core";
import { EligibilityDistributionDto } from "generated/openApi";
import { DevExpressReport } from "components";
import { Column } from "devextreme-react/data-grid";
import { useEligibilityData } from "../contexts/EligibilityDataContext";
import { DashboardCard } from "../components/DashboardCard";
import { EligibilityFilterControls } from "./EligibilityFilterControls";

const EligibilityTableContent = () => {
    const { data, loading, error } = useEligibilityData();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Stack
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                flexWrap="wrap"
                useFlexGap
                gap={2}
                sx={{ mb: 2 }}
            >
                <EligibilityFilterControls />
            </Stack>

            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                {loading ? (
                    <Skeleton variant="rounded" height={500} />
                ) : error ? (
                    <Box sx={{ p: 2, color: "error.main" }}>{error}</Box>
                ) : (
                    <DevExpressReport
                        dashboardStyle
                        dataSource={data}
                        fullPageSize
                        showColumnChooser={false}
                    >
                        <Column
                            dataField={pn<EligibilityDistributionDto>("eligibilityName")}
                            caption="Eligibility"
                        />
                        <Column
                            dataField={pn<EligibilityDistributionDto>("studentCount")}
                            caption="Count"
                        />
                        <Column
                            dataField={pn<EligibilityDistributionDto>("percentage")}
                            caption="%"
                            cellRender={(cellData) => `${cellData.value}%`}
                        />
                    </DevExpressReport>
                )}
            </Box>
        </Box>
    );
};

export const EligibilityTableCard = () => {
    const { data } = useEligibilityData();

    const handleExport = () => {
        if (!data || data.length === 0) return;

        const headers = ["Eligibility", "Count", "%"];
        const rows = data.map((item) => [
            `"${item.eligibilityName}"`,
            item.studentCount,
            `${item.percentage}%`,
        ]);

        const csvContent = [
            headers.join(","),
            ...rows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "EligibilityCriteria.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <DashboardCard title="Eligibility Criteria" onExport={handleExport}>
            <EligibilityTableContent />
        </DashboardCard>
    );
};
